/* Bundle entry — side-effect imports of every frontend module in the exact
 * load order index.html used for the 11 separate <script defer> tags.  The
 * modules keep their window-attach pattern (each does `window.Foo = …` for
 * siblings to read); esbuild bundles them in this order, so the global
 * attaches happen before dependents run — identical semantics to the prior
 * ordered <script> tags, but one hashed, cache-immutable module.
 *
 * React/ReactDOM stay global (loaded from the CDN before this module runs);
 * they are NOT imported here, so esbuild leaves the `React.createElement`
 * references pointing at window.React.
 *
 * mobile.jsx is deliberately NOT imported here: app.jsx dynamic-import()s it
 * only when the viewport crosses the mobile breakpoint, so esbuild code-splits
 * it into a separate hashed chunk that desktop operators never download. */
import "./tweaks-panel.jsx";
import "./ws.jsx";
import "./data.jsx";
import "./data-live.jsx";
import "./ui.jsx";
import "./pages.jsx";
import "./strategy-ledger.jsx";   /* window.StrategyLedger — mounted by PageStrategies */
/* CR/Alerts/Ops console — loaded AFTER pages.jsx so its window.PageResearch /
 * PageAlerts / PageTechops (+ openCritAlertCount) override the prior versions.
 * Order within: css (inject scoped style) → data (OpsStore + helpers) → ui
 * (shared components) → the three page modules. */
import "./ops-css.jsx";
import "./ops-data.jsx";
import "./ops-ui.jsx";
import "./alerts2.jsx";
import "./research2.jsx";
import "./ops2.jsx";
import "./configs.jsx";
import "./market.jsx";
import "./login.jsx";
import "./app.jsx";

/* Mobile chunk pre-fetch: app.jsx only dynamic-import()s mobile.jsx from an
 * effect AFTER React has booted and rendered once — on a phone that made the
 * chunk a full extra network round-trip serialized behind bundle parse +
 * first render (the "mobile loads slower than desktop" waterfall).  Kick the
 * same import off here, at bundle-eval time, when the viewport is already
 * mobile: the fetch runs in parallel with React boot + /api bootstrap, and
 * app.jsx's later import() resolves instantly from the module cache.
 * Desktop viewports still never download the chunk. */
if (typeof window.matchMedia === "function" &&
    window.matchMedia("(max-width: 760px)").matches) {
  import("./mobile.jsx").catch(() => {});
}
